<template>
  <div>
    <!-- 确认：拒绝申请： -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="562px" center>
      <div class="content">
        <div class="prompt" v-if="isNotarize" style="color: #67C23A;">确认该条出入金变更申请，确认后将直接写入客户出入金记录</div>
        <div class="prompt" v-else>是否拒绝该条出入金变更申请，拒绝后状态将变更为不通过状态。</div>
        <!-- 登记时间 -->
        <div class="row">
          <div class="label">{{ $t('message.registrationTime') }}</div>
          <div class="value">{{ datas.created_at }}</div>
        </div>
        <!-- 申请人:  -->
        <div class="row">
          <div class="label">{{ $t('message.theApplicant') }}</div>
          <div class="value">{{ datas.created_by_admin.realname }}</div>
        </div>
        <!-- 申请原因: -->
        <div class="row">
          <div class="label">{{ $t('message.reasonForApplication') }}</div>
          <div class="value">{{ datas.adjust_reason }}</div>
        </div>
        <!-- 出入金类型 -->
        <div class="row">
          <div class="label">{{ $t('message.depositWithdrawalType') }}</div>
          <div class="value">{{ datas.type_name }}</div>
        </div>
        <!-- 出入金金额  -->
        <div class="row">
          <div class="label">{{ $t('message.depositWithdrawalAmount') }}</div>
          <div class="value">{{ datas.amount }}円</div>
        </div>
        <!-- 审核备注   -->
        <div class="row">
          <div class="label">{{ $t('message.reviewRemarks') }}</div>
          <div class="value">
            <el-input v-model="confirm_remark" type="textarea"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 确认变更 -->
        <el-button type="success" @click="adjustApplicationConfirm" v-if="isNotarize">{{
          $t('message.confirmModification') }}</el-button>
        <!-- 拒绝申请 -->
        <el-button type="primary" @click="adjustApplicationReject" v-else>{{ $t('message.rejectApplication')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: {
        created_by_admin: {}
      },
      confirm_remark: '',
      isNotarize: false,
      title: ''
    };
  },
  methods: {
    //确认申请
    adjustApplicationConfirm() {
      this.$api.financialApi.adjustApplicationConfirm({ id: this.datas.id, confirm_remark: this.confirm_remark }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.adjustApplicationListTab()
        this.$parent.adjustApplicationList()
      })
    },
    //取消申请
    adjustApplicationReject() {
      this.$api.financialApi.adjustApplicationReject({ id: this.datas.id, confirm_remark: this.confirm_remark }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.adjustApplicationListTab()
        this.$parent.adjustApplicationList()
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 0 20px;
  font-size: 16px;

  .prompt {
    color: red;
    margin-bottom: 15px;
  }

  .row {
    display: flex;
    margin-bottom: 15px;

    .label {
      width: 120px;
      margin-right: 12px;
    }
  }
}
</style>